import { forwardRef } from 'react';
import cx from 'clsx';

import Button from '@/components/button/button';

import styles from '../styles.module.scss';

const ButtonDanger = forwardRef((props, ref) => {
  const { className, labelClassName, ...buttonProps } = props;

  return (
    <Button
      ref={ref}
      className={cx(styles.dangerButton, className)}
      labelClassName={cx(styles.dangerButtonLabel, labelClassName)}
      {...buttonProps}
      data-testid="danger-button"
    />
  );
});

export default ButtonDanger;
